import React, {useEffect, useState} from 'react';
import {Button, Modal, Select} from "antd";
import axios from "axios";
import {toast} from "react-toastify";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {API_PATH, WS_PATH} from "../../components/const";
import ReactPlayer from "react-player";

const RoiVisitorLive = () => {
    const [users, setUsers] = useState([])
    const [offices, setOffices] = useState([])
    const [roiList, setRoiList] = useState([])
    const [rooms, setRooms] = useState([])
    const [cameras, setCameras] = useState([])
    const [selectOffices, setSelectOffices] = useState(null)
    const [selectRooms, setSelectRooms] = useState(null)
    const [selectCameraShow, setselectCameraShow] = useState(false)
    const [sendData, setSendData] = useState(null)
    const [message, setMessage] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectImg, setSelectImg] = useState("");
    const [selectCameras, setSelectCameras] = useState("")
    const [parents, setParents] = useState([])

    const showModal = (e) => {
        setSelectImg(e)
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    var color_choices = [
        "#00FF47",
    ];

    var img = new Image();
    var rgb_color = color_choices[Math.floor(Math.random() * color_choices.length)]
    var opaque_color = 'rgba(0, 255, 71, 0.22)';
    // var scaleFactor = 1;
    var canvas = document.getElementById('canvas');
    var ctx = canvas?.getContext('2d');
    function drawPolygon(vertices) {

        ctx?.beginPath();
        ctx.strokeStyle = rgb_color;
        ctx.lineWidth = "10";
        ctx?.moveTo(vertices[0].x, vertices[0].y);

        for (var i = 1; i < vertices.length; i++) {
            ctx?.lineTo(vertices[i].x, vertices[i].y);
        }

        ctx?.closePath();
        ctx?.stroke();
        ctx.fillStyle = opaque_color; // Set the fill color
        ctx.fill();
    }
    const getVideo = (e) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/" + e, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                setSelectCameras(res?.data?.ddns_stream_url)
                // console.log(res?.data?.ddns_stream_url)
            })
    }
    function drawroi(e, roiId) {
        var canvas = document.getElementById('canvas');
        var ctx = canvas.getContext('2d');

        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/" + e, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                img.src = res?.data?.screenshot;

                img.onload = function () {
                    let scaleFactor = 0.35;
                    canvas.style.width = img.width * scaleFactor + 'px';
                    canvas.style.height = img.height * scaleFactor + 'px';
                    canvas.width = img.width  ;
                    canvas.height = img.height  ;

                    canvas.style.borderRadius = '12px';
                    canvas.style.border = '0';
                    ctx.drawImage(img, 0, 0);

                    axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/roi_analytics/" + e + "/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                        .then(res2 => {
                            setRoiList(res2?.data)
                            if (roiId){
                                drawPolygon( roiId?.sort((a, b) => a.order_number - b.order_number))
                            } else {
                                if (res2?.data[0]?.points?.length > 0 ){
                                    for (let i=0; i < res2.data?.length; i++){
                                        drawPolygon( res2?.data[i]?.points?.sort((a, b) => a.order_number - b.order_number))
                                    }
                                }
                            }
                        })
                };
            })
    }
    const getBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
                setSendData({...sendData, buildings_id: res.data.id})

            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }


    const getParentBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/sections/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setParents(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getRooms = (id) => {
        getCameras(id)
        setSelectOffices(id)
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/room/" + id + "/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setRooms(res.data?.items)
                setSendData({...sendData, room_id: res.data.id})
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getRoomsSearch = (val) => {
        getCameras(selectOffices)
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/room/" + selectOffices + "/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setRooms(res.data?.items)
                setSendData({...sendData, room_id: res.data.id})
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getCameras = (id) => {
        setSelectRooms(id)
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/all?building_id=" + id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setCameras(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
        window.scrollTo(0, 0);
    }
    const getCamerasOnlyBuilding = (id) => {
        setSelectRooms(id)

        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/by/room/" + id + "/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setCameras(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
        window.scrollTo(0, 0);

    }
    const getCamerasSearch = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/all?building_id=" + selectRooms + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setCameras(res?.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
        window.scrollTo(0, 0);
    }

    const getAll = (id) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/roi/event/" + id + "/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setUsers(res?.data?.items)
            })


        const socket = new WebSocket("wss://socket.cradle-vision.com/roicamera" + id + "/connect");
        socket.onmessage = (event) => {

            setMessage(JSON.parse(event?.data?.replace(/'/g, '"')));
            setUsers(prevUsers => [{
                employee:
                    {
                        first_name: JSON.parse(event?.data?.replace(/'/g, '"')).row[15],
                        last_name: JSON.parse(event?.data?.replace(/'/g, '"')).row[16],
                        image: JSON.parse(event?.data?.replace(/'/g, '"')).row[17],

                    }
                ,
                time_interval: JSON.parse(event?.data?.replace(/'/g, '"')).row[7],
                description: JSON.parse(event?.data?.replace(/'/g, '"')).row[8],
                visitor_id: JSON.parse(event?.data?.replace(/'/g, '"')).row[4],
                kassa_number: JSON.parse(event?.data?.replace(/'/g, '"')).row[5],
            },
                ...prevUsers
            ]);

            // setUsers(prevUsers => [JSON.parse(event?.data?.replace(/'/g, '"')), ...prevUsers]);
        };
        return () => {
            socket.close();
        };

    }
    useEffect(() => {
        localStorage.setItem("sec", "")
        getBuilding()
        getParentBuilding()
    }, []);


    useEffect(() => {


    }, [message])

    return (
        <div className="live-page">
            <div className="employees-header">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="left-head">
                        <h6>ROI Visitor </h6>
                        <p>ROI рассмотрение</p>
                    </div>
                    <div className="right-head d-flex">
                        <div className="inputs-box mr-16" style={{width: "200px"}}>
                            <Select
                                showSearch
                                placeholder="Выберите раздел"
                                optionFilterProp="children"
                                className="w-100"
                                onSearch={getParentBuilding}
                                onChange={(e) => getBuilding(e)}
                                // onChange={(e) => setCountry(e)}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={parents?.map((item) => {
                                    return {
                                        value: item.id,
                                        label:
                                        item?.branch_title
                                    };
                                })}
                            />
                        </div>
                        <div className="inputs-box mr-16" style={{width: "200px"}}>
                            <Select
                                showSearch
                                placeholder="Выберите филиал"
                                optionFilterProp="children"
                                className="w-100"
                                onSearch={getBuilding}
                                onChange={(e) => getRooms(e)}
                                // onChange={(e) => setCountry(e)}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={offices?.map((item) => {
                                    return {
                                        value: item.building_id,
                                        label:
                                        item?.branch_title
                                    };
                                })}
                            />
                        </div>
                        <div className="inputs-box mr-16" style={{width: "200px"}}>
                            <Select
                                showSearch
                                placeholder="Выбрать комнату"
                                optionFilterProp="children"
                                className="w-100"
                                onSearch={getRoomsSearch}
                                onChange={(e) => getCamerasOnlyBuilding(e)}
                                // onChange={(e) => setCountry(e)}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={rooms?.map((item) => {
                                    return {
                                        value: item.id,
                                        label:
                                        item?.name
                                    };
                                })}
                            />
                        </div>
                        <div className="inputs-box" style={{width: "200px"}}>
                            <Select
                                showSearch
                                placeholder="Выберите камеру"
                                optionFilterProp="children"
                                className="w-100"
                                onSearch={getCamerasSearch}
                                onChange={(e) => {
                                    setselectCameraShow(true)
                                    // drawroi(e)
                                    getAll(e)
                                    getVideo(e)
                                }}
                                // onChange={(e) => setCountry(e)}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={cameras?.map((item) => {
                                    return {
                                        value: item.id,
                                        label:
                                        item?.name
                                    };
                                })}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="live-page-box">
                {/*<div className="live-page-box-header">*/}

                {/*    <div className="left d-flex justify-content-center w-100 " style={{borderRadius: "12px", background: "#D9D9D9"}}>*/}
                {/*    */}
                {/*        <canvas className={selectCameraShow ? "" : "d-none"} style={{borderRadius: '0px !important' }} id="canvas"></canvas>*/}
                {/*    */}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="left-pair w-100">

                    {
                        selectCameras ? <ReactPlayer url={selectCameras}
                                                     className=" w-65   h-100 " style={{borderRadius: "8px", marginLeft: "auto", marginRight: "auto"}}
                                                     playing={true} muted/>
                            :
                            ""
                    }
                </div>

                {
                    selectCameraShow
                        ?
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650}} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="pl20 table-head"
                                                   style={{width: "140px"}}>Сотрудник</TableCell>
                                        <TableCell className="table-head" align="left">visitor_id</TableCell>
                                        <TableCell className="table-head" align="left">Касса</TableCell>
                                        {/*<TableCell className="table-head" align="left"></TableCell>*/}

                                        <TableCell className="pr20 table-head" align="left">Время</TableCell>
                                        <TableCell className="table-head" align="right">Описание</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        users?.slice(0, 20)?.map((item, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                            >
                                                <TableCell className="pl20"  component="th"
                                                           scope="row">
                                                    <div className="d-flex align-items-center">
                                                        <img
                                                            onClick={() => showModal(item?.employee?.image)}
                                                            src={(item?.employee?.image?.slice(0, 8) === "https://" || item?.employee?.image?.slice(0, 7) === "http://")  ? item?.employee?.image : ("https://" + item?.employee?.image)}
                                                            alt="img" className="mr-8"
                                                            style={{width: "40px", borderRadius: "4px"}}/>

                                                        <span>{item?.employee?.first_name ? item?.employee?.first_name : ""}</span>
                                                        <span className="ml-8">{item?.employee?.last_name ? item?.employee?.last_name : ""}</span>
                                                    </div>

                                                </TableCell>


                                                <TableCell className="pr20 con-btns-all"
                                                           align="left">{item?.visitor_id}</TableCell>

                                                <TableCell className="pr20 con-btns-all"
                                                           align="left">{item?.kassa_number}</TableCell>
                                                {/*<TableCell className="pr20 con-btns-all"*/}
                                                {/*           align="left">{item?.action_type }</TableCell>*/}
                                                {/*<TableCell className="pr20 con-btns-all"*/}
                                                {/*           align="left">{item?.created_at ? (item?.created_at?.slice(0, 10) + " / " + item?.created_at?.slice(11, 16)) : (time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" +  Number(time?.getDate())  + " / " ) }</TableCell>*/}

                                                <TableCell className="pr20 con-btns-all"
                                                           align="left">{item?.time_interval }</TableCell>
                                                <TableCell className="pr20 con-btns-all"
                                                           align="right">{item?.description}</TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        :
                        ""
                }

            </div>
            <Modal title="Скриншот"
                   open={isModalOpen}
                   onCancel={handleCancel}
                   footer={[
                       <Button key="submit" type="default" onClick={handleCancel}>
                           Отменить
                       </Button>,
                   ]}
            >
                <img src={(selectImg?.slice(0, 8) === "https://" || selectImg?.slice(0, 7) === "http://")  ? selectImg : ("https://" + selectImg)} className="w-100" alt=""/>
            </Modal>
        </div>
    );
};

export default RoiVisitorLive;